import {Component, Input, OnInit, } from '@angular/core';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass } from '@angular/common';
import { Subscription, debounceTime, distinctUntilChanged, tap } from 'rxjs';
import { PortalHotToastService } from '../portal-hot-toast-component/hot-toast.service';
import { DEFAULT_LIMIT, DEFAULT_OFFSET, GetActiveCreditUsersFn, UpdateCreditAssignableFn, UserOmitPriviledges } from '@portal-workspace/grow-shared-library';
import { FlexModule } from '@angular/flex-layout';
import { CustomContentLoaderComponent } from "../custom-content-loader-component/custom-content-loader.component";
import { CustomPaginatorComponent } from '../custom-paginator-component/custom-paginator/custom-paginator.component';
import { MatTableModule } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { loadingFor } from '@ngneat/loadoff';
import { DatePipe, AsyncPipe, } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import moment from 'moment';
import { MatSlideToggleModule, MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
    selector: 'credit-officers',
    templateUrl: './credit-officers.component.html',
    styleUrls: ['./credit-officers.component.scss'],
    standalone: true,
    imports: [
      MatTableModule, 
      NgClass, 
      ExtendedModule, 
      FlexModule,
      CustomContentLoaderComponent,
      CustomPaginatorComponent,
      MatSortModule,
      DatePipe,
      AsyncPipe,
      MatButtonModule,
      MatInputModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatTooltipModule,
      MatSlideToggleModule,
    ]
})
export class CreditOfficersComponent implements OnInit {
  @Input({required: true}) getActiveCreditUsersFn!: GetActiveCreditUsersFn;
  @Input({required: true}) updateCreditAssignableFn!: UpdateCreditAssignableFn;

  subscriptions: Subscription[] = [];
  moment = moment;
  formControlSearch!: FormControl<string | null>;

  total = 0;
  limit = DEFAULT_LIMIT;
  offset = DEFAULT_OFFSET;
  filter = '';
  loader = loadingFor('tableLoading');
  dataSource: UserOmitPriviledges[] = [];
  filteredDataSource: UserOmitPriviledges[] = [];
  displayedData: UserOmitPriviledges[] = [];
  columnsToDisplay = ['UserId', 'Name', 'Email', 'Assignable'];

  constructor(
    private formBuilder: FormBuilder,
    private toastService: PortalHotToastService,
  ) {
    this.formControlSearch = this.formBuilder.control(null);
  }

  ngOnInit(): void {
    this.reload();

    this.subscriptions.push(
      this.formControlSearch.valueChanges.pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        tap(r => {
          if (r) {
            const text = r.trim().toLowerCase();
              this.filteredDataSource = this.dataSource.filter(item => 
                (`${item?.Name?.trim().toLowerCase()} ${item?.Email?.trim().toLowerCase()} }`).includes(text)
              );
            this.initPagination();
          } else {
            this.filteredDataSource = this.dataSource;
            this.initPagination();
          }
        })
      ).subscribe()
    )

  }

  reload() {
    this.subscriptions.push(
      this.getActiveCreditUsersFn().pipe(
        this.loader.tableLoading.track()
      ).subscribe(items => {
        this.dataSource = items;
        this.filteredDataSource = this.dataSource;
        this.initPagination();
      })
    )
  }

  getColumnTitles(column: string): string {
    switch (column) {
      case 'UserId': return 'User ID';
      case 'Name': return 'Name';
      case 'Email': return 'Email';
      case 'assignable': return 'Assignable';
      default: return column;
    }
  }

  initPagination() {
    this.total = this.filteredDataSource.length;
    this.limit = DEFAULT_LIMIT;
    this.offset = DEFAULT_OFFSET;
    this.updateDisplayedData();
  }

  updateDisplayedData() {
    this.displayedData = this.filteredDataSource.slice(this.offset * this.limit, (this.offset + 1) * this.limit);
  }
  
  onPagination($event: PageEvent) {
    this.limit = $event.pageSize;
    this.offset = $event.pageIndex;
    this.updateDisplayedData();
  }

  onchangeAssignable($event:MatSlideToggleChange, element: UserOmitPriviledges){
    if($event.checked){
      this.updateCreditAssignableFn(element.UserId, true).pipe(
        this.toastService.snackBarObservable(`Assignable marked as credit assignable`)
      ).subscribe((res:any) => {
        if(res){
          this.reload();
        }
      });
    }
    else{
      this.updateCreditAssignableFn(element.UserId, false).pipe(
        this.toastService.snackBarObservable(`Assignable marked as not credit assignable`)
      ).subscribe((res:any) => {
        if(res){
          this.reload();
        }
      });
    }
  }
}
